import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { format } from "date-fns";
import { useFormik } from "formik";
import tentStyles from "../TentHouseService.module.css";
import * as Yup from "yup";
import { styled } from "@mui/material/styles";
import styles from "../PriestManagerService.module.css";
import caterStyles from "./CateringService.module.css";
import cardStyles from "./editandcreate.module.css";
import config from "../../../config";
import noimage from '../../../assets/images/Desktop placeholder.svg';
import backgroundimage from "../../../assets/images/cateringbackground_image.png";
import ServiceForm from "./ServiceForm";
import nopackageimage from "../../../assets/images/Group 2_11zon.png";

import { confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";

import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";

import { fetchServices } from "../../../Apiservices/Auth/servers/fetchServices";
import { getServiceProviderProfile } from "../../../Apiservices/Auth/servers/profileServer";
import "../ServiceProviderDashboard.css";

import {
  updateServiceProviderServices,
  addServiceProviderServices,
  editServiceProviderServices,
  addPriestEventServices,
  deletePriestEventServices,
} from "../../../Apiservices/Auth/servers/updateServiceProviderServices";
import {

  deleteCateringProviderServices,
  getCateringItemMasterList,
  getCateringProviderCategories,
  getCateringProviderCuisines,
  getCateringProviderServices,
  getimagesidforcateringcusines,
  getCateringCategoryList,
  
} from "../../../Apiservices/Auth/servers/fetchProviderData";
import {
  createCateringPackage,
  fetchCateringPackages,
  updateCateringPackage,
} from "../../../Apiservices/Auth/servers/cateringPackageService";
import { useCuisineMasters } from "./useCuisineMasters";
import { fetchCategoryEvents } from '../../../Apiservices/Auth/servers/fetchCategoryEvents';
import CollapseExpandTree from "../../CustomComponents/CollapseExpandTree";

import {
  searchSelectCateringText,
  searchSelectEventText,
} from "../../../constant";

function CateringService(prop) {
  console.log('🔄 CateringService rendering');

  const [includedItems, setIncludedItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [allMasterItems, setAllMasterItems] = useState([]);
  const [sidessallMasterItems, sidessetAllMasterItems] = useState([]);
  const [unitTypeList, setUnitTypeList] = useState([]);

  const [providerServices, setProviderServices] = useState([]);
  // Add new service data
  const [resultedServices, setResultedServices] = useState([]);
  // Veg/Non Veg data
  const [mealTypes, setMealTypes] = useState([]);
  // Cuisine Type
  const [cuisines, setCuisines] = useState([]);
  const [cusinemealimagesids, setcusinemealimagesid] = useState([])
  // At top of component
  const [selectedcategory, setselectedcategory] = useState(null)
  const [fetchedevents, setfetchedevents] = useState(null)
  const [editServices, setEditServices] = useState({});
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [loading, setLoading] = useState(true);
  const toast = useRef(null);
  const detailsModalRef = useRef(null);
  const detailsCloseButtonRef = useRef(null);
  const detailsTriggerRef = useRef(null);
  const {
    cuisines: cuisineMasters,
    loading: cuisineMastersLoading,
    error: cuisineMastersError,
  } = useCuisineMasters(selectedcategory);

  // FIXED: Use ref for fetchProviderServices to break circular dependencies
  const fetchProviderServicesRef = useRef(null);

  // FIXED: Memoize filteredServices
  const filteredServices = useMemo(() => {
    return selectedcategory
      ? providerServices.filter(
        (service) => service.meal?.meal_id === selectedcategory
      )
      : [];
  }, [selectedcategory, providerServices]);

  // FIXED: Memoize API functions
  const fetchMealTypes = useCallback(async () => {
    const mealTypes = await getCateringProviderCategories();

    if (mealTypes) {
      setMealTypes(mealTypes);
      fetchCategories(mealTypes[0]?.meal_id)
    }
  }, []);

  const fetchCategories = useCallback(async (selected_meal_type_id) => {
    const categories = await getCateringCategoryList(selected_meal_type_id);

    if (categories) {
      setCategories(categories);
    }
  }, []);

  const fetchCuisines = useCallback(async () => {
    const cuisines = await getCateringProviderCuisines();

    console.log("cuisines", cuisines);
    if (cuisines) {
      setCuisines(cuisines);
    }

  }, []);

  // FIXED: Initialize fetchProviderServicesRef
  useEffect(() => {
    fetchProviderServicesRef.current = async () => {
      try {
        const addedServices = await fetchCateringPackages();
        const fetchedEvents = await fetchCategoryEvents();
        if (fetchedEvents) {
          setfetchedevents(fetchedEvents);
        }

        const formattedServices = addedServices.map(service => ({
          ...service,
          regular_price: service.regular_price ? Math.floor(parseFloat(service.regular_price)) : null,
          discounted_price: service.discounted_price ? Math.floor(parseFloat(service.discounted_price)) : null,
        }));
        setProviderServices(formattedServices);
      } catch (error) {
        console.error("Unable to load catering packages:", error);
        toast.current?.show({
          severity: "error",
          summary: "Packages unavailable",
          detail: error.message || "Unable to load catering packages.",
          life: 4000,
        });
      }
    };
  }, []);

  useEffect(() => {
    const fetchDropdownData = async () => {
      const masterItems = await getCateringItemMasterList({
        exclude_side_items: false,
      });
      const sidemasterItems = await getCateringItemMasterList({
        exclude_side_items: true,
      });

      console.log("testingdata", masterItems, sidemasterItems);
      sidessetAllMasterItems(
        sidemasterItems?.filter(
          (item) => item?.category?.id !== null && item?.category?.name !== 'Uncategorized'
        ) ?? []
      );

      setAllMasterItems(
        (masterItems ?? [])?.filter(
          (item) => item?.category?.id !== null && item?.category?.name !== 'Uncategorized'
        )
      );

      // const unitTypes = await getCateringUnitTypeList();

      // setUnitTypeList(unitTypes ?? null);
    };

    fetchDropdownData();
  }, []);

  // FIX: Initialize includedItems from resultedServices
  const resultedServicesFunc = useCallback(async () => {
    setLoading(true);
    try {
      const cateringServices = await getCateringProviderServices();
      console.log("cateringServices", cateringServices);
      setResultedServices(cateringServices);
      const getcusinemealimagesids = await getimagesidforcateringcusines()
      if (getcusinemealimagesids) {
        console.log("getcusinemealimagesids", getcusinemealimagesids.data)
        setcusinemealimagesid(getcusinemealimagesids.data)
      }
      // FIX: Initialize includedItems here
      const includedItemsMap = cateringServices?.map((meal) => {
        console.log("Mapping meal:", meal, "id:", meal.id, "meal_id:", meal.meal_id);
        return {
          meal_id: meal.meal_id || meal.id,
          meal_name: meal.meal_name || meal.name || meal.label,
          defaults: meal.defaults,
          imageid: meal.image?.id || null,
        };
      }) || [];

      console.log("cateringServices includedItemsMap", includedItemsMap)
      setselectedcategory(includedItemsMap[0].meal_id)
      fetchCategories(includedItemsMap[0].meal_id)
      setIncludedItems(includedItemsMap);
    } catch (error) {
      console.error("Failed to services:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Clear edit mode when category changes
  useEffect(() => {
    setEditServices({});
    setShowCreateForm(false);
  }, [selectedcategory]);

  useEffect(() => {
    fetchMealTypes();
    fetchCuisines();
    if (fetchProviderServicesRef.current) {
      fetchProviderServicesRef.current();
    }
    resultedServicesFunc();
  }, [fetchMealTypes, fetchCuisines, resultedServicesFunc]);

  // FIXED: Memoize all handler functions
  const handleDelete = useCallback(async (itemId) => {
    setLoading(true);
    const toDeleteService = {
      itemIds: [itemId],
    };

    try {
      await deleteCateringProviderServices(toDeleteService);
      console.log('✅ Service deleted successfully');
      if (fetchProviderServicesRef.current) {
        await fetchProviderServicesRef.current();
      }
    } catch (error) {
      console.error("Failed to delete service:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const deleteServiceConfirm = useCallback((serviceID) => {
    confirmDialog({
      message: "Do you want to delete this service?",
      header: "Delete Confirmation",
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      accept: () => handleDelete(serviceID),
      reject,
    });
  }, [handleDelete]);

  const reject = useCallback(() => { }, []);

  const handleEdit = useCallback((serviceId) => {
    console.log('🔍 [handleEdit] Editing service ID:', serviceId);
    setEditServices(prev => ({
      [serviceId]: true
    }));
    console.log('scrollY before:', window.scrollY);

    // Use setTimeout to ensure state update and DOM rendering happens first
    setTimeout(() => {
      window.scrollTo({
        top: 450,
        behavior: 'smooth'
      });
    }, 100);
  }, []);

  // FIXED: Create service with proper dependencies
  const handleCreateService = useCallback(async (formData) => {
    try {
      console.log('🔧 [handleCreateService] Creating service with data:', formData);

      // Map cuisine category names to IDs
      const mapCuisineCategoryToId = (cuisineCategory) => {
        if (!cuisineCategory) return null;
        const name = cuisineCategory.name || cuisineCategory;
        switch (name.toLowerCase()) {
          case 'vegetarian':
          case 'veg':
            return 1;
          case 'non-vegetarian':
          case 'non vegetarian':
          case 'nonveg':
          case 'non-veg':
            return 2;
          default:
            return null;
        }
      };

      // Function to find item and get cuisine category
      const findItemCuisineCategory = (itemName, itemId) => {
        // Search in allMasterItems
        for (const categoryGroup of allMasterItems) {
          const foundItem = categoryGroup.items.find(item =>
            (itemId && item.id === itemId) || item.itemName === itemName
          );
          if (foundItem) {
            return foundItem.cuisineCategory;
          }
        }

        // Search in sidessallMasterItems
        for (const categoryGroup of sidessallMasterItems) {
          const foundItem = categoryGroup.items.find(item =>
            (itemId && item.id === itemId) || item.itemName === itemName
          );
          if (foundItem) {
            return foundItem.cuisineCategory;
          }
        }

        return null;
      };

      // Determine the main category_id based on included items
      const determineMainCategoryId = () => {
        // Check all included items
        for (const item of formData.included_items) {
          const cuisineCategory = findItemCuisineCategory(item.itemName, item.itemId);
          const categoryId = mapCuisineCategoryToId(cuisineCategory);
          if (categoryId) {
            return categoryId; // Return the first valid category found
          }
        }

        return null; // Return null if no category found
      };

      const finalCreateData = {
        event_ids: formData.event_ids || [],
        category_id: formData.category_id ?? determineMainCategoryId(),
        meal_id: Number(selectedcategory),
        type_id: 1,
        min_people: 100,
        regular_price: parseFloat(formData.regular_price) || 0,
        discounted_price: formData.discounted_price
          ? parseFloat(formData.discounted_price)
          : null,
        valid_until: formData.valid_until || null,
        custom_combo_name: formData.custom_combo_name,
        description: formData.description || null,
        image_ids: formData.image_ids ?? [],
        included_items: formData.included_items
          .filter(item => item.itemName && item.qty)
          .map(item => ({
            itemName: item.itemName,
            qty: parseInt(item.qty) || 1,
            itemId: item.itemId || null,
            unitType: item.unitType || "",
            itemGroupId: item.itemGroupId || null,
          })),
        included_side_items: [],
      };

      const selectedCuisineMasterId = Number(formData.catering_package_cuisine_master_id);
      if (Number.isFinite(selectedCuisineMasterId) && selectedCuisineMasterId > 0) {
        finalCreateData.catering_package_cuisine_master_id = selectedCuisineMasterId;
      }

      console.log('🔧 [handleCreateService] Final create data:', finalCreateData);

      const response = await createCateringPackage(finalCreateData);
      console.log('✅ Service created successfully:', response);

      if (fetchProviderServicesRef.current) {
        await fetchProviderServicesRef.current();
      }
      setShowCreateForm(false);

    } catch (error) {
      console.error('Error creating service:', error);
      throw error;
    }
  }, [selectedcategory, allMasterItems, sidessallMasterItems]);

  const handleEditService = useCallback(async (formData) => {
    try {
      console.log('🔧 [handleEditService] Updating service with data:', formData);

      // Map cuisine category names to IDs
      const mapCuisineCategoryToId = (cuisineCategory) => {
        if (!cuisineCategory) return null;
        const name = cuisineCategory.name || cuisineCategory;
        switch (name.toLowerCase()) {
          case 'vegetarian':
          case 'veg':
            return 1;
          case 'non-vegetarian':
          case 'non vegetarian':
          case 'nonveg':
          case 'non-veg':
            return 2;
          default:
            return null;
        }
      };

      // Function to find item and get cuisine category
      const findItemCuisineCategory = (itemName, itemId) => {
        // Search in allMasterItems
        for (const categoryGroup of allMasterItems) {
          const foundItem = categoryGroup.items.find(item =>
            (itemId && item.id === itemId) || item.itemName === itemName
          );
          if (foundItem) {
            return foundItem.cuisineCategory;
          }
        }

        // Search in sidessallMasterItems
        for (const categoryGroup of sidessallMasterItems) {
          const foundItem = categoryGroup.items.find(item =>
            (itemId && item.id === itemId) || item.itemName === itemName
          );
          if (foundItem) {
            return foundItem.cuisineCategory;
          }
        }

        return null;
      };

      // Determine the main category_id based on included items
      const determineMainCategoryId = () => {
        // Check all included items
        for (const item of formData.included_items) {
          const cuisineCategory = findItemCuisineCategory(item.itemName, item.itemId);
          const categoryId = mapCuisineCategoryToId(cuisineCategory);
          if (categoryId) {
            return categoryId; // Return the first valid category found
          }
        }


        return null; // Return null if no category found
      };

      const parsedCuisineMasterId = Number(formData.catering_package_cuisine_master_id);
      const cuisineMasterId = Number.isFinite(parsedCuisineMasterId) && parsedCuisineMasterId > 0
        ? parsedCuisineMasterId
        : null;

      const updateData = {
        item_id: formData.item_id,
        event_ids: formData.event_ids || [],
        category_id: formData.category_id ?? determineMainCategoryId(),
        meal_id: Number(formData.meal_id || selectedcategory),
        type_id: 1,
        min_people: 100,
        regular_price: parseFloat(formData.regular_price) || 0,
        discounted_price: formData.discounted_price !== null && formData.discounted_price !== ''
          ? parseFloat(formData.discounted_price)
          : null,
        valid_until: formData.valid_until || null,
        custom_combo_name: formData.custom_combo_name,
        description: formData.description || null,
        image_ids: formData.image_ids ?? [],
        included_items: formData.included_items
          .filter(item => item.itemName && item.qty)
          .map(item => ({
            itemName: item.itemName,
            unitType: item.unitType || "",
            qty: parseInt(item.qty) || 1,
            itemId: item.itemId || null,
            itemGroupId: item.itemGroupId || null,
          })),
        included_side_items: [],
        catering_package_cuisine_master_id: cuisineMasterId,
      };
      console.log("updatecateringdate", updateData)
      await updateCateringPackage(updateData);

      // Refresh services after manual submit
      if (fetchProviderServicesRef.current) {
        await fetchProviderServicesRef.current();
      }

      // Exit edit mode after successful submission
      setEditServices(prev => {
        const newState = { ...prev };
        delete newState[formData.item_id];
        return newState;
      });

      toast.current?.show({
        severity: "success",
        summary: "Package updated",
        detail: "Your catering package was updated successfully.",
        life: 3000,
      });

    } catch (error) {
      console.error('Error updating service:', error);
      throw error;
    }
  }, [selectedcategory, allMasterItems, sidessallMasterItems]);

  const handleFormSubmit = useCallback(async (formData, isEditMode = false) => {
    console.log('[handleFormSubmit] Received formData:', {
      isEditMode,
      item_id: formData.item_id,
      serviceName: formData.custom_combo_name
    });

    const hasNonVeg = includedItems.some(includedItem => {
      // Find the corresponding master item
      const masterItem = allMasterItems.find(master => master.itemId === includedItem.itemId);

      // If master item is found and it's non-veg, return true
      return masterItem && masterItem.isVeg === false; // or whatever property indicates non-veg
    });

    // Set category_id based on the check
    formData.category_id = hasNonVeg ? 2 : 1;
    if (isEditMode) {
      return handleEditService(formData);
    } else {
      return handleCreateService(formData);
    }
  }, [handleEditService, handleCreateService, includedItems, allMasterItems]);

  // FIXED: Memoize all other handlers
  const handleCreateNew = useCallback(() => {
    setShowCreateForm(true);
    window.scrollTo({
      top: 450,
      behavior: 'smooth'
    });
  }, []);

  const handleFormCancel = useCallback(() => {
    setShowCreateForm(false);
  }, []);

  const handleCancel = useCallback((serviceId) => {
    setEditServices(prev => {
      const newState = { ...prev };
      delete newState[serviceId];
      return newState;
    });
  }, []);

  const isServiceEditing = useCallback((serviceId) => {
    return !!editServices[serviceId];
  }, [editServices]);

  // Check if any service is being edited
  const isAnyServiceEditing = useMemo(() => {
    return Object.values(editServices).some(editing => editing);
  }, [editServices]);

  const closeServiceDetails = useCallback(() => {
    setSelectedService(null);
    window.requestAnimationFrame(() => detailsTriggerRef.current?.focus());
  }, []);

  useEffect(() => {
    if (!selectedService) return undefined;

    const previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    detailsCloseButtonRef.current?.focus();
    const handleDialogKeyDown = (event) => {
      if (event.key === "Escape") {
        closeServiceDetails();
        return;
      }

      if (event.key === "Tab") {
        const focusableElements = detailsModalRef.current?.querySelectorAll(
          'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (!focusableElements?.length) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    };

    document.addEventListener("keydown", handleDialogKeyDown);
    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.removeEventListener("keydown", handleDialogKeyDown);
    };
  }, [selectedService, closeServiceDetails]);

  const openServiceDetails = useCallback((service, trigger) => {
    if (isServiceEditing(service.item_id)) return;
    detailsTriggerRef.current = trigger;
    setSelectedService(service);
  }, [isServiceEditing]);

  const isInteractiveTarget = (target, card) => {
    const interactiveElement = target.closest(
      'button, input, select, textarea, a, [role="button"], [contenteditable="true"]'
    );
    return interactiveElement && interactiveElement !== card;
  };

  // FIXED: Memoize ServiceForm props to prevent unnecessary re-renders
  const getServiceFormProps = useCallback((service, isEditing) => ({
    isPackageMode: true,
    service: service,
    onSubmit: handleFormSubmit,
    cuisines: cuisines,
    onCancel: () => handleCancel(service.item_id),
    categories: includedItems,
    types: mealTypes,
    includedItemsList: providerServices,
    itemsCategories: categories,
    allMasterItems: allMasterItems,
    sidessallMasterItems: sidessallMasterItems,
    isEditing: isEditing,
    mode: isEditing ? "edit" : "view",
    onToggleEdit: () => handleEdit(service.item_id), // This passes the service.item_id to handleEdit
    selectedcategory: selectedcategory,
    fetchedevents: fetchedevents,
    cuisineMasters,
    cuisineMastersLoading,
    cuisineMastersError,
  }), [
    handleFormSubmit,
    handleCancel,
    handleEdit,
    includedItems,
    mealTypes,
    providerServices,
    allMasterItems,
    sidessallMasterItems,
    selectedcategory,
    fetchedevents,
    cuisineMasters,
    cuisineMastersLoading,
    cuisineMastersError,
  ]);

  return (
    <>
      <Toast ref={toast} />
      <div className={caterStyles.cateringcontainer}>

        {loading ? (
          <div>
            <h3 style={{ textAlign: "center" }}>
              <i
                className="pi pi-spin pi-spinner-dotted"
                style={{ fontSize: "2rem", color: "#0cc0df" }}
              ></i>
            </h3>
          </div>
        ) : (
          <>
            {/* Left category */}
            {/* !isAnyServiceEditing &&  */}

            <div className={caterStyles.backgroundImage}></div>

            <div className={caterStyles.leftcontainer}>
              {includedItems.length > 0 ? (
                includedItems.map((item) => {
                  // Find the corresponding image data for this meal_id
                  const mealImageData = cusinemealimagesids?.find(
                    (imageItem) => imageItem.meal_id === item.meal_id
                  );
                  //  console.log("gugugu", item);
                  // Get the image URL if available
                  const imageUrl = item?.imageid
                    ? `${config.API_BASE_URL}/gallery/download/${item.imageid}`
                    : noimage;

                  return (
                    <div
                      key={item.meal_id}
                      className={
                        selectedcategory === item.meal_id
                          ? `${caterStyles.showitemswithimage} ${caterStyles.active}`
                          : caterStyles.showitemswithimage
                      }
                      onClick={() => {
                        setselectedcategory(item.meal_id);
                        fetchCategories(item.meal_id);
                      }}
                    >
                      <img
                        src={imageUrl}
                        alt={item.meal_name}
                        className={caterStyles.imagesize}
                        onError={(e) => {
                          // Fallback to noimage if the API image fails to load
                          e.target.src = noimage;
                        }}
                      />
                      <div className={caterStyles.itemLabel}>{item.meal_name}</div>
                    </div>
                  );
                })
              ) : (
                <p>No meal categories available</p>
              )}
            </div>

            {/* Right content */}
            <div className={caterStyles.rightcontainer}>
              <div className={caterStyles.rightcontainerwrapper}>
                {selectedcategory ? (
                  <>
                    {/* Global Header for Edit/Create mode */}
                    {(isAnyServiceEditing || showCreateForm) && (
                      <div className={caterStyles.globalHeader}>
                        <button
                          type="button"
                          onClick={() => {
                            if (isAnyServiceEditing) {
                              // Find the service being edited and cancel it
                              const editingServiceId = Object.keys(editServices).find(id => editServices[id]);
                              if (editingServiceId) {
                                handleCancel(editingServiceId);
                              }
                            } else if (showCreateForm) {
                              handleFormCancel();
                            }
                          }}
                          className={caterStyles.backButton}
                          title="Go back"
                        >
                          <i className="pi pi-arrow-left"></i>
                        </button>
                        <span className={caterStyles.globaltext}>
                          {isAnyServiceEditing ? 'Edit Your Package' : 'Create Your Menu'}
                        </span>
                      </div>
                    )}

                    {/* Add New Service Button - Show when not in create mode and no service is being edited */}
                    {!showCreateForm && !isAnyServiceEditing && (
                      <div className={caterStyles.addNewContainer}>
                        <button
                          onClick={handleCreateNew}
                          className={caterStyles.addNewBtn}
                        >
                          <i className="pi pi-plus" style={{ fontSize: "12px" }}></i> Add my own menu
                        </button>
                      </div>
                    )}

                    {/* Show create form when creating new service */}
                    {showCreateForm && (
                      <ServiceForm
                        mode="create"
                        isPackageMode={true}
                        fetchedevents={fetchedevents}
                        onSubmit={handleFormSubmit}
                        onCancel={handleFormCancel}
                        categories={includedItems}
                        itemsCategories={categories}
                        cuisines={cuisines}
                        types={mealTypes}
                        includedItemsList={providerServices}
                        allMasterItems={allMasterItems}
                        sidessallMasterItems={sidessallMasterItems}
                        cuisineMasters={cuisineMasters}
                        cuisineMastersLoading={cuisineMastersLoading}
                        cuisineMastersError={cuisineMastersError}
                        selectedcategory={selectedcategory}
                      />
                    )}

                    {/* Show existing service cards — tent house style grid */}
                    {!showCreateForm && !isAnyServiceEditing && filteredServices.length > 0 && (
                      <div className={cardStyles.cateringPackagesGrid}>
                        {filteredServices.map((service) => {
                          const images = (() => {
                            if (service.gallery && Array.isArray(service.gallery)) return service.gallery.map(img => img.id || img).filter(Boolean);
                            if (service.image_ids && Array.isArray(service.image_ids)) return service.image_ids;
                            return [];
                          })().slice(0, 2);

                          return (
                            <div key={service.item_id} className={cardStyles.cateringPackageCard}>
                              {/* Card Header */}
                              <div className={cardStyles.cateringCardHeader}>
                                <h3 className={cardStyles.cateringCardTitle}>
                                  {service.custom_combo_name || 'Untitled Package'}
                                </h3>
                                <div className={cardStyles.cateringCardActions}>
                                  <button
                                    className={cardStyles.cateringEditBtn}
                                    onClick={() => handleEdit(service.item_id)}
                                  >
                                    Edit
                                  </button>
                                  <button
                                    className={cardStyles.cateringDeleteBtn}
                                    onClick={(e) => { e.stopPropagation(); deleteServiceConfirm(service.item_id); }}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </div>

                              {/* Images */}
                              {images.length > 0 && (
                                <div
                                  className={cardStyles.cateringCardImageRow}
                                  style={{ gridTemplateColumns: images.length === 2 ? '1fr 1fr' : '1fr' }}
                                >
                                  {images.map((imgId, idx) => (
                                    <img
                                      key={idx}
                                      src={`${config.API_BASE_URL}/gallery/download/${imgId}`}
                                      alt={`${service.custom_combo_name} - ${idx + 1}`}
                                      className={cardStyles.cateringCardImage}
                                      onError={(e) => { e.target.style.display = 'none'; }}
                                    />
                                  ))}
                                </div>
                              )}

                              {/* Description */}
                              {service.description && (
                                <p className={cardStyles.cateringCardDescription}>{service.description}</p>
                              )}

                              {/* Price Details */}
                              <div className={cardStyles.cateringCardDetails}>
                                {service.regular_price != null && (
                                  <div className={cardStyles.cateringCardDetail}>
                                    <span className="detailLabel">Price</span>
                                    <span className="detailValue">₹{Math.floor(service.regular_price)}</span>
                                  </div>
                                )}
                                {service.discounted_price != null && (
                                  <div className={cardStyles.cateringCardDetail}>
                                    <span className="detailLabel">Offer Price</span>
                                    <span className="detailValue">₹{Math.floor(service.discounted_price)}</span>
                                  </div>
                                )}
                                {service.mealName && (
                                  <div className={cardStyles.cateringCardDetail}>
                                    <span className="detailLabel">Meal</span>
                                    <span className="detailValue">{service.mealName}</span>
                                  </div>
                                )}
                                {service.cuisineMaster?.name && (
                                  <div className={cardStyles.cateringCardDetail}>
                                    <span className="detailLabel">Cuisine</span>
                                    <span className="detailValue">{service.cuisineMaster.name}</span>
                                  </div>
                                )}
                              </div>

                              {/* Events */}
                              {service.event_ids?.length > 0 && fetchedevents && (
                                <div className={cardStyles.cateringCardSection}>
                                  <h4>Suitable Events</h4>
                                  <div className={cardStyles.cateringCardTagsRow}>
                                    {fetchedevents
                                      .reduce((acc, cat) => {
                                        const evts = cat.events || (cat.id ? [cat] : []);
                                        return [...acc, ...evts];
                                      }, [])
                                      .filter(e => service.event_ids.includes(e.id))
                                      .slice(0, 4)
                                      .map(e => (
                                        <span key={e.id} className={cardStyles.cateringCardTag}>{e.name}</span>
                                      ))}
                                    {service.event_ids.length > 4 && (
                                      <span className={cardStyles.cateringCardTag}>+{service.event_ids.length - 4} more</span>
                                    )}
                                  </div>
                                </div>
                              )}

                              {/* Items */}
                              {service.included_items?.length > 0 && (
                                <div className={cardStyles.cateringCardSection}>
                                  <h4>Items ({service.included_items.length})</h4>
                                  <div className={cardStyles.cateringCardItemsList}>
                                    {service.included_items.slice(0, 3).map((item, idx) => (
                                      <div key={idx} className={cardStyles.cateringCardItem}>
                                        <span>{item.itemName || `Item ${idx + 1}`}</span>
                                        <span className={cardStyles.cateringCardItemQty}>×{item.qty}</span>
                                      </div>
                                    ))}
                                    {service.included_items.length > 3 && (
                                      <div className={cardStyles.cateringCardItem} style={{ color: '#9ca3af', fontStyle: 'italic' }}>
                                        +{service.included_items.length - 3} more items
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {/* Edit form — shown when a service is being edited */}
                    {isAnyServiceEditing && !showCreateForm && filteredServices.map((service) => {
                      const isEditing = isServiceEditing(service.item_id);
                      if (!isEditing) return null;
                      const serviceFormProps = getServiceFormProps(service, true);
                      return (
                        <div key={service.item_id}>
                          <ServiceForm
                            {...serviceFormProps}
                            mode="edit"
                          />
                        </div>
                      );
                    })}

                    {!showCreateForm && !isAnyServiceEditing && filteredServices.length === 0 && (
                      <div className={cardStyles.cateringNoPackages}>
                        <p>No packages created yet.</p>
                        <span>Click "Add my own menu" to create your first package.</span>
                      </div>
                    )}
                  </>
                ) : (
                  <p>Click the menu to create your Package</p>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      {selectedService && (
        <div
          className={caterStyles.detailsModalBackdrop}
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              closeServiceDetails();
            }
          }}
        >
          <div
            ref={detailsModalRef}
            className={caterStyles.detailsModal}
            role="dialog"
            aria-modal="true"
            aria-labelledby={`service-details-title-${selectedService.item_id}`}
            onMouseDown={(event) => event.stopPropagation()}
          >
            <div className={caterStyles.detailsModalHeader}>
              <h2 id={`service-details-title-${selectedService.item_id}`}>
                {selectedService.custom_combo_name || "Service details"}
              </h2>
              <button
                ref={detailsCloseButtonRef}
                type="button"
                className={caterStyles.detailsCloseBtn}
                onClick={closeServiceDetails}
              >
                <i className="pi pi-times" aria-hidden="true"></i>
                Close
              </button>
            </div>
            <div className={caterStyles.detailsModalBody}>
              <ServiceForm
                {...getServiceFormProps(selectedService, false)}
                mode="view"
                showServiceActions={false}
                detailsView
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default React.memo(CateringService);
